import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LegalPageLayout } from './LegalPageLayout';

export const TermsView: FC = () => {
  const { t } = useTranslation();

  return (
    <LegalPageLayout title={t('legal.termsTitle')}>
      <p>{t('legal.termsBody')}</p>
    </LegalPageLayout>
  );
};

TermsView.displayName = 'TermsView';

export const PrivacyView: FC = () => {
  const { t } = useTranslation();

  return (
    <LegalPageLayout title={t('legal.privacyTitle')}>
      <p>{t('legal.privacyBody')}</p>
    </LegalPageLayout>
  );
};

PrivacyView.displayName = 'PrivacyView';

export const ContactsView: FC = () => {
  const { t } = useTranslation();

  return (
    <LegalPageLayout title={t('legal.contactsTitle')}>
      <p>{t('legal.contactsBody')}</p>
      <p className="font-medium">{t('legal.contactsEmail')}</p>
    </LegalPageLayout>
  );
};

ContactsView.displayName = 'ContactsView';
